/* ConditionalDropdownData.js */

"use strict";

const CONDITIONAL_DATA = {
    string: {
        equal: { label: "Equals", fields: 1, type: "text" },
        not_equal: { label: "Not Equals", fields: 1, type: "text" },
        contains: { label: "Contains", fields: 1, type: "text" },
        in: { label: "In", fields: 1, type: "text" },
        not_in: { label: "Not in", fields: 1, type: "text" },
        is_empty: { label: "Is Empty", fields: 0 },
        is_not_empty: { label: "Is not empty", fields: 0 },
        is_null: { label: "Is Null", fields: 0 },
        is_not_null: { label: "Is not Null", fields: 0 },
        not_begins_with: { label: "Doesn't start with", fields: 1, type: "text" },
        begins_with: { label: "Starts with", fields: 1, type: "text" },
        ends_with: { label: "Ends with", fields: 1, type: "text" },
        not_ends_with: { label: "Doesn't end with", fields: 1, type: "text" },
        not_contains: { label: "Doesn't contain", fields: 1, type: "text" }
    },
    enum: {
        equal: { label: "Equals", fields: 1, type: "dropdown" },
        not_equal: { label: "Not Equals", fields: 1, type: "dropdown" }
    },
    number: {
        equal: { label: "Equals", fields: 1, type: "number" },
        not_equal: { label: "Not Equals", fields: 1, type: "number" },
        greater: { label: "greater", fields: 1, type: "number" },
        greater_or_equal: { label: "greater or equal", fields: 1, type: "number" },
        less: { label: "less", fields: 1, type: "number" },
        less_or_equal: { label: "less or equal", fields: 1, type: "number" },
        between: { label: "between", fields: 2, type: "number" },
        not_between: { label: "not between", fields: 2, type: "number" },
        in: { label: "In", fields: 1, type: "text" },
        not_in: { label: "Not in", fields: 1, type: "text" }
    },
    duration: {
        equal: { label: "Equals", fields: 1, type: "number" },
        not_equal: { label: "Not Equals", fields: 1, type: "number" },
        greater: { label: "greater", fields: 1, type: "number" },
        greater_or_equal: { label: "greater or equal", fields: 1, type: "number" },
        less: { label: "less", fields: 1, type: "number" },
        less_or_equal: { label: "less or equal", fields: 1, type: "number" },
        between: { label: "between", fields: 2, type: "number" },
        not_between: { label: "not between", fields: 2, type: "number" },
        in: { label: "In", fields: 1, type: "text" },
        not_in: { label: "Not in", fields: 1, type: "text" }
    },
    unixTime: {
        equal: { label: "Equals", fields: 1, type: "date" },
        not_equal: { label: "Not Equals", fields: 1, type: "date" },
        greater: { label: "greater", fields: 1, type: "date" },
        greater_or_equal: { label: "greater or equal", fields: 1, type: "date" },
        less: { label: "less", fields: 1, type: "date" },
        less_or_equal: { label: "less or equal", fields: 1, type: "date" },
        between: { label: "between", fields: 2, type: "date" },
        not_between: { label: "not between", fields: 2, type: "date" },
        in: { label: "In", fields: 1, type: "text" },
        not_in: { label: "Not in", fields: 1, type: "text" }
    },
    boolean: {
        equal: { label: "Equals", fields: 2, type: "radio" }
    }
};

module.exports = {
    CONDITIONAL_DATA
};
